module.exports = __webpack_public_path__ + "images/emoji/pray.a32c32b77dc49156e6ce.png";